import { methodSteps } from "@/mocks/gossip";

export default function Method() {
  return (
    <section id="method" className="scroll-mt-28 border-t border-background-200 bg-foreground-950 py-12 text-background-100 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-widest text-accent-300">Our Method</span>
            <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-background-50 md:text-4xl">
              吃瓜方法论：六步还原一套瓜
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-200">
              深扒不是挖得更狠，而是查得更稳。我们把每次还原都收敛成同一套流程，让「线索拼接 → 深度解析」有章可循、有据可依。
            </p>
          </div>
          <span className="flex shrink-0 items-center gap-2 rounded-full bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50">
            <i className="ri-check-double-line h-4 w-4"></i>
            每篇专题都按此执行
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-2xl bg-background-800 sm:grid-cols-2 lg:grid-cols-3">
          {methodSteps.map((m) => (
            <div key={m.step} className="group bg-foreground-950 p-6 transition-colors hover:bg-foreground-900">
              <div className="flex items-center justify-between">
                <span className="font-heading text-3xl font-black text-primary-500">{m.step}</span>
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-background-800 text-accent-300 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className={`${m.icon} h-6 w-6`}></i>
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-background-50">{m.title}</h3>
              <p className="mt-2 text-sm leading-7 text-foreground-300">{m.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}